<template>
  <main v-if="tournament">
    <RoundRobin v-if="tournament.isRR()"></RoundRobin>
    <Brackets v-if="[1,3].includes(tournament.type)"></Brackets>
    <Tft v-if="tournament.isTFT()"></Tft>
  </main>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import RoundRobin from "../views/RoundRobin/RoundRobin";
import Brackets from '../components/Brackets'
import Tft from '../views/Tft/Tft'
export default {
  props: {
    id: {
      required: true
    }
  },
  computed: {
    ...mapGetters({
      tournament: 'tournament/tournament'
    }),
    getId () {
      return Math.abs(+this.id)
    }
  },
  methods: {
    ...mapActions({
      getTournament: 'tournament/getTournament'
    })
  },
  async mounted () {
    await this.getTournament(this.getId)
  },
  components: {
    Tft,
    RoundRobin,
    Brackets
  }
}
</script>
